import {management} from '../../../../index'
import {LogSectorRepository} from '../../../infra/knex/repositories/log_sector'

import {ShowByTimeAndIdSector} from './showByTimeAndIdSector'

export const showLogSectorByIdAndTimeUseCase=()=>{
    const repository=new LogSectorRepository(management)

    const logSector= new ShowByTimeAndIdSector(repository)

    return logSector
}
